import { extractAirlineCarriers } from "@/app/lib/utils/extractAirlineCarriers";
import { OrderLabel } from "./my-bookings/OrderLabel";
import { sumDuration } from "../lib/utils/duration";
import type {
  FindUserReservationsExternalFlightReservation,
  FindUserReservationsFlightReservation,
  FindUserReservationsFlightReservationFlight,
} from "../lib/types/codegen";
import { SingleFlightInfo } from "./SingleFlightInfo";
import {
  SingleAvailableFlight,
  type Props as SingleAvailableFlightProps,
} from "./SingleAvailableFlight";

const SingleFlightReservationInfo = ({
  flight,
}: {
  flight: FindUserReservationsFlightReservationFlight;
}) => {
  const firstSegment = flight.segments[0];
  const lastSegment = flight.segments[flight.segments.length - 1];

  const duration = sumDuration([
    ...flight.stops.map((stop) => stop.stopTime),
    ...flight.segments.map((segment) => segment.flightDuration),
  ]);

  return (
    <SingleFlightInfo
      origin={{
        date: firstSegment.origin.date,
        time: firstSegment.origin.time,
        code: firstSegment.origin.code,
      }}
      destination={{
        date: lastSegment.destination.date,
        time: lastSegment.destination.time,
        code: lastSegment.destination.code,
      }}
      duration={duration}
      stops={flight.stops?.length || 0}
      operatedBy={
        //  does operating carrier differ from marketing carrier
        firstSegment.operatingCarrier &&
        firstSegment.marketingCarrier &&
        firstSegment.operatingCarrier.code !==
          firstSegment.marketingCarrier.code
          ? firstSegment.operatingCarrier.name ||
            firstSegment.operatingCarrier.code
          : undefined
      }
    />
  );
};

type Props = Pick<SingleAvailableFlightProps, "bottomInfo" | "onClick"> & {
  itinerary: FindUserReservationsExternalFlightReservation;
  reservationStatus?: FindUserReservationsFlightReservation["status"];
};

function SingleAvailableFlightReservation({
  itinerary,
  reservationStatus,
  bottomInfo,
  onClick,
}: Props) {
  const allAirlines = extractAirlineCarriers(
    itinerary.flights.flatMap((f) => f.segments),
  );

  return (
    <SingleAvailableFlight
      onClick={onClick}
      airlines={allAirlines}
      topInfo={
        reservationStatus ? <OrderLabel status={reservationStatus} /> : null
      }
      bottomInfo={bottomInfo}
    >
      <SingleFlightReservationInfo flight={itinerary.flights[0]} />
      {itinerary.flights[1] && (
        <SingleFlightReservationInfo flight={itinerary.flights[1]} />
      )}
    </SingleAvailableFlight>
  );
}

export default SingleAvailableFlightReservation;
